import { cn } from '@/app/utils/cn';

/**
 * Base reset styles for input elements.
 */
export const INPUT_RESET = cn(
  'appearance-none outline-none focus:outline-none'
);

/**
 * Error text color for inputs.
 */
export const INPUT_TEXT_ERROR = cn('text-crimson-500');

/**
 * Base utility class for input controls (checkbox, radio, etc.).
 */
export const CONTROL_BASE = cn(
  INPUT_RESET,
  'shrink-0 cursor-pointer border-2 before:-inset-1'
);

/**
 * Utility class to hide the pseudo-element's border (used for control interactions).
 */
export const HIDE_BEFORE_BORDER = cn('before:border-transparent!');

/**
 * Base transition utility for form animations.
 */
export const FORM_TRANSITION = cn('transition-form');
